
<div class="header-toolbar">
  <h1>{{ title }}</h1>
</div>


  <!-- Toolbar -->
  <div class="main btn-toolbar">
        
    <a class="btn" (click)="cancel()">
      <t-icon name="arrow_back"></t-icon>
      <span class="text">Retour</span>
    </a>

  </div>
  <!-- /Toolbar -->

  <div class="grid" *ngIf="settings">

    <div class="column">

      <div class="panel">
        <h2>Liste des catégories de registres</h2>
      
        <table *ngIf="settings.ledgerTemplates.length > 0">
          <tbody>
            <tr *ngFor="let template of settings.ledgerTemplates; index as index">
              <td>{{ template.name }}</td>
              <td style="font-size: 11px;">{{ template.signed ? '[Avec documents signés]' : '' }}</td>
              <td style="width: 50px;" class="actions">
                <a class="action-btn" title="Supprimer" (click)="deleteLedgerTemplate(index)">
                  <t-icon name="delete"></t-icon>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      
        <div class="empty-table compact" *ngIf="settings.ledgerTemplates.length === 0">
          <p>La liste est vide</p>
        </div>

        <h2 style="border-top: solid 1px #DDDDDD; border-bottom: solid 1px #DDDDDD; padding-top: 16px;">
          Ajouter une catégorie de registre
        </h2>

        <div class="form-group">
          <input name="name" type="text" placeholder="Nom du registre" [formControl]="name" maxlength="200" (keyup)="nameKeyup($event)" autocomplete="off"/>
          
          <div class="inputs-row right" style="padding-top: 12px;">
            <label>Avec documents signés</label>
            <t-option [(value)]="template.signed"></t-option>

            <a class="btn btn-small btn-gray" (click)="addLedgerTemplate()">
              <t-icon name="add"></t-icon>
              <span class="text">Ajouter</span>
            </a>
          </div>
        </div>
      
      </div>

    </div>

    <div class="column"></div>

  </div>